//  Defined default store

export default {
	testStore: 'This is test from ApolloStore',
}
